
/* LOAN_CALCULATE */
export const CALCULATE_LOAN = "CALCULATE_LOAN";
export const CALCULATE_LOAN_SUCCESS = "CALCULATE_LOAN_SUCCESS";
export const CALCULATE_LOAN_FAIL = "CALCULATE_LOAN_FAIL";

export const RESET_LOAN_CALCULATE_STATE = 'RESET_LOAN_CALCULATE_STATE';
export const RESET_LOAN_CALCULATE_ACTION_STATE = 'RESET_LOAN_CALCULATE_ACTION_STATE';